<h4>{{"formConfig.editor.tools.fields"|translate}}</h4>
<section id="fields" class="field-list">
    <div class="left-field-column"></div>
    <div class="right-field-column"></div>
</section>
<h4>{{"formConfig.editor.tools.sections"|translate}}</h4>
<section id="sections" class="section-list">
    <div class="section-column"></div>
</section>